import Link from 'next/link';
import { useEffect } from 'react';
import { IoClose } from 'react-icons/io5';
import ReactModal from 'react-modal';

import { OFFERS } from '../../constants/routes';
import { productsForOrder } from '../../store/cart';
import { Order } from '../../store/order';
import { PrimaryButton, SecondaryButton } from '../Buttons/Buttons';
import modalStyles from '../GenericModal/GenericModal.module.scss';

import styles from './ProductChangesModal.module.scss';
import ProductTileChanged from './ProductTileChanged';

export default function ProductsChangesModal({
  isModalOpen,
  setIsModalOpen,
  updatedProducts = [],
  unavailableProducts = [],
  modifyProduct,
}) {
  const unavailableLabel = 'Μη διαθέσιμα προϊόντα';
  const updatedLabel = 'Προϊόντα με ανανεωμένες τιμές';
  const modalText =
    'Οι τιμές και η διαθεσιμότητα κάποιων προϊόντων που έχεις στο καλάθι σου έχει αλλάξει. Το καλάθι σου θα ανανεωθεί αυτόματα.';

  function closeModal() {
    setIsModalOpen(false);
  }

  useEffect(() => {
    const productsInCart = productsForOrder.getStorageValue();
    if (updatedProducts.length) {
      const productsNotUpdatedInCart = productsInCart.filter(
        product => !updatedProducts.some(p => product._id === p._id)
      );
      productsForOrder.update([...productsNotUpdatedInCart, ...updatedProducts]);
    }
    if (unavailableProducts.length) {
      const availableProductsInCart = productsInCart.filter(
        product => !unavailableProducts.some(p => product._id === p._id)
      );
      productsForOrder.update(availableProductsInCart);
    }
    const [orderProducts = [], orderOffers = []] = modifyProduct();

    const products = orderProducts.length ? orderProducts : undefined;
    Order.setProducts(products);

    const offers = orderOffers.length ? orderOffers : undefined;
    Order.setOffers(offers);
  }, [updatedProducts, unavailableProducts]);

  return (
    <ReactModal
      className={styles.content}
      overlayClassName={modalStyles.overlay}
      portalClassName={modalStyles.modal}
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      contentLabel="Aνανέωση προϊόντων καλαθιού"
      ariaHideApp={false}
    >
      <div className={styles.header}>
        <h1 className={styles.headerTitle}>Aνανέωση προϊόντων καλαθιού</h1>
        <button type="button" className={styles.closeBtn} onClick={closeModal}>
          <IoClose className={styles.closeModal} />
        </button>
      </div>

      <div className={styles.body}>
        <p className={styles.message}>{modalText}</p>
        {updatedProducts.length !== 0 && (
          <section>
            <h2 className={styles.sectionTitle}>{updatedLabel}</h2>
            <div className={styles.productsContainer}>
              {updatedProducts.map(product => (
                <ProductTileChanged product={product} />
              ))}
            </div>
          </section>
        )}
        {unavailableProducts.length !== 0 && (
          <section>
            <h2 className={styles.sectionTitle}>{unavailableLabel}</h2>
            <div className={styles.productsContainer}>
              {unavailableProducts.map(product => (
                <ProductTileChanged product={product} unavailable />
              ))}
            </div>
          </section>
        )}
      </div>

      <div className={styles.footer}>
        <Link href={OFFERS}>
          <a className={styles.btnSecondary}>
            <SecondaryButton>Επιστροφή στα προϊόντα</SecondaryButton>
          </a>
        </Link>
        <div className={styles.rightButton}>
          <PrimaryButton onClick={closeModal}>Συνέχεια</PrimaryButton>
        </div>
      </div>
    </ReactModal>
  );
}
